/* TheBitezz redesign (v4): cart drawer, header, search and the interactive parts of every bt-* section.
   Store data (free-delivery amount, upsell products) comes from window.BT, printed by sections/bt-footer.liquid. */
(() => {
  const C = window.BT || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const FREE_AT = C.freeAt || 50000;
  const PACK_GRAMS = 170;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = cents => '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: cents % 100 ? 2 : 0 });
  const esc = s => String(s ?? '').replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]);
  const packsOf = grams => Math.max(1, Math.round(grams / PACK_GRAMS));
  const shortLabel = t => String(t || '').split(' (')[0].split(' – ')[0];
  const sized = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';
  const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  // ---------- Toast and confetti ----------
  function toast(text) {
    const el = $('[data-bt-toast]');
    if (!el) return;
    el.textContent = text;
    el.classList.add('is-on');
    clearTimeout(toast.t);
    toast.t = setTimeout(() => el.classList.remove('is-on'), 2200);
  }
  function confetti(from) {
    if (reduceMotion || !from || !from.getBoundingClientRect) return;
    const r = from.getBoundingClientRect(), x0 = r.left + r.width / 2, y0 = r.top + r.height / 2;
    const colors = ['#FFB320', '#E0302A', '#6A3C9E', '#7ED6A5', '#FF8FA0', '#3A1A0E'];
    for (let i = 0; i < 28; i++) {
      const c = document.createElement('i');
      c.className = 'bt-confetti';
      c.style.cssText = `background:${colors[i % colors.length]};left:${x0}px;top:${y0}px`;
      document.body.appendChild(c);
      const a = Math.random() * Math.PI * 2, d = 60 + Math.random() * 120;
      c.animate([
        { transform: 'translate(0,0) rotate(0)', opacity: 1 },
        { transform: `translate(${Math.cos(a) * d}px, ${Math.sin(a) * d - 60}px) rotate(${Math.random() * 720}deg)`, opacity: 1, offset: .6 },
        { transform: `translate(${Math.cos(a) * d * 1.2}px, ${Math.sin(a) * d + 80}px) rotate(${Math.random() * 900}deg)`, opacity: 0 }
      ], { duration: 900 + Math.random() * 400, easing: 'cubic-bezier(.2,.7,.4,1)' }).onfinish = () => c.remove();
    }
  }

  // ---------- Layers: cart drawer, mobile menu, search ----------
  let openEl = null, lastFocus = null;
  function openLayer(name) {
    const el = $(`[data-bt-layer="${name}"]`);
    if (!el) return;
    closeLayer(false);
    lastFocus = document.activeElement;
    openEl = el;
    el.classList.add('is-on');
    el.setAttribute('aria-hidden', 'false');
    $('[data-bt-scrim]')?.classList.add('is-on');
    document.documentElement.classList.add('bt-lock');
    if (name === 'search') { const i = $('[data-bt-search-input]'); i.value = ''; renderSearch(); }
    setTimeout(() => (el.querySelector('[data-bt-focus]') || el).focus(), 50);
  }
  function closeLayer(restore = true) {
    if (!openEl) return;
    openEl.classList.remove('is-on');
    openEl.setAttribute('aria-hidden', 'true');
    $('[data-bt-scrim]')?.classList.remove('is-on');
    document.documentElement.classList.remove('bt-lock');
    openEl = null;
    if (restore && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // ---------- Cart (Shopify AJAX API) ----------
  let cart = null;
  const cartListeners = [];
  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    cart = await r.json();
    renderCart();
    return cart;
  }
  async function addToCart(items, btn) {
    items = items.filter(i => i.id && i.quantity > 0);
    if (!items.length) return;
    btn && btn.classList.add('is-busy');
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items }) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Sorry, that could not be added.');
      await fetchCart();
      $$('[data-bt-count]').forEach(d => { d.classList.add('is-bump'); setTimeout(() => d.classList.remove('is-bump'), 260); });
      confetti(btn);
      toast('Yay! Added to your cart');
      setTimeout(() => openLayer('cart'), 420);
      return true;
    } catch (e) {
      toast(e.message);
      return false;
    } finally {
      btn && btn.classList.remove('is-busy');
    }
  }
  async function changeLine(key, quantity) {
    const r = await fetch('/cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: key, quantity }) });
    if (r.ok) { cart = await r.json(); renderCart(); }
    else toast('Sorry, that could not be updated.');
  }

  function shipMessage(sub) {
    const left = FREE_AT - sub;
    if (!sub) return `🚚 Free delivery on orders of ${money(FREE_AT)} and above`;
    return left > 0 ? `🚚 You're <b>${money(left)}</b> away from free delivery` : '🎉 Woohoo! You\'ve unlocked <b>free delivery</b>';
  }
  function upsellFor(c) {
    const has = h => c.items.some(it => it.handle === h);
    const hasCombo = C.combo && has(C.combo.handle);
    const banana = C.upsell && C.upsell.banana, choco = C.upsell && C.upsell.choco;
    const left = FREE_AT - c.total_price;
    if (choco && !has(choco.handle) && !hasCombo) return [choco, 'Kids love switching flavours'];
    if (banana && !has(banana.handle) && !hasCombo) return [banana, 'Make it a combo'];
    if (banana && left > 0 && left <= banana.price) return [banana, 'One more pack = free delivery!'];
    return null;
  }
  function renderCart() {
    if (!cart) return;
    $$('[data-bt-count]').forEach(d => { d.textContent = cart.item_count; d.hidden = !cart.item_count; });
    cartListeners.forEach(fn => fn(cart));
    const body = $('[data-bt-cart-body]');
    if (!body) return;
    const sub = cart.total_price;
    $('[data-bt-cart-meter]').style.width = Math.min(100, sub / FREE_AT * 100) + '%';
    $('[data-bt-cart-ship]').innerHTML = shipMessage(sub);
    $('[data-bt-cart-foot]').hidden = !cart.item_count;
    $('[data-bt-cart-subtotal]').textContent = money(sub);
    if (!cart.item_count) {
      body.innerHTML = `<div class="bt-empty">${C.mascot ? `<img src="${esc(C.mascot)}" alt="" class="bt-wiggle" width="150" height="137">` : ''}<h3>Your plate is empty!</h3><p>Start with one pack, or try both flavours in the Combo.</p>${C.combo ? `<button type="button" class="bt-btn bt-btn--red" data-bt-add-one="${C.combo.id}">Add the Combo · ${money(C.combo.price)}</button>` : ''}</div>`;
      return;
    }
    body.innerHTML = cart.items.map(it => {
      const packs = packsOf(it.grams) * it.quantity;
      return `<div class="bt-line">
        <img src="${esc(sized(it.image, 200))}" alt="" width="78" height="78" loading="lazy">
        <div>
          <div class="bt-line__top"><a href="${esc(it.url)}">${esc(it.product_title)}</a><span>${money(it.final_line_price)}</span></div>
          <div class="bt-line__sub">${it.variant_title ? esc(shortLabel(it.variant_title)) + ' · ' : ''}makes ${packs * 7}–${packs * 8} pancakes</div>
          <div class="bt-line__bottom">
            <span class="bt-stepper"><button type="button" data-bt-line="${esc(it.key)}" data-qty="${it.quantity - 1}" aria-label="One less ${esc(it.product_title)}">−</button><output>${it.quantity}</output><button type="button" data-bt-line="${esc(it.key)}" data-qty="${it.quantity + 1}" aria-label="One more ${esc(it.product_title)}">+</button></span>
            <button type="button" class="bt-remove" data-bt-line="${esc(it.key)}" data-qty="0">Remove</button>
          </div>
        </div>
      </div>`;
    }).join('');
    const up = upsellFor(cart);
    if (up) {
      const [p, why] = up;
      body.insertAdjacentHTML('beforeend', `<div class="bt-upsell"><img src="${esc(sized(p.image, 120))}" alt="" width="56" height="56"><div><strong>${esc(p.title)}</strong><span>${why}</span></div><button type="button" class="bt-btn bt-btn--cocoa bt-btn--sm" data-bt-add-one="${p.id}">+ ${money(p.price)}</button></div>`);
    }
  }

  // ---------- Search: Shopify predictive search plus our own quick links ----------
  let searchTimer = null, searchSeq = 0;
  const hitHTML = r => `<a class="bt-hit" href="${esc(r.url)}">${r.image ? `<img src="${esc(sized(r.image, 120))}" alt="" width="56" height="56">` : '<i>→</i>'}<span><strong>${esc(r.title)}</strong><small>${esc(r.sub || '')}</small></span>${r.price ? `<b>${esc(r.price)}</b>` : ''}</a>`;
  async function renderSearch() {
    const input = $('[data-bt-search-input]'), out = $('[data-bt-search-results]');
    if (!input || !out) return;
    const q = input.value.trim(), seq = ++searchSeq;
    $('[data-bt-search-quick]').hidden = !!q;
    const links = C.links || [];
    if (!q) { out.innerHTML = links.slice(0, 3).map(hitHTML).join(''); return; }
    const terms = q.toLowerCase().split(/\s+/);
    const linkHits = links.filter(l => terms.every(t => (l.title + ' ' + l.words).toLowerCase().includes(t)));
    let products = [];
    try {
      const r = await fetch(`${C.searchUrl || '/search/suggest.json'}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`);
      const data = await r.json();
      products = ((data.resources && data.resources.results && data.resources.results.products) || []).map(p => ({ title: p.title, url: p.url, image: p.image, sub: 'Pancake mix', price: 'From ' + money(Math.round(parseFloat(p.price_min || p.price) * 100)) }));
    } catch (e) { /* offline: show the quick links only */ }
    if (seq !== searchSeq) return;
    const hits = [...products, ...linkHits];
    out.innerHTML = hits.length ? hits.map(hitHTML).join('') : `<p class="bt-search__empty">No results for "${esc(q)}". Try "banana", "choco" or "combo".</p>`;
  }

  // ---------- Header: ticker and mega menu ----------
  function initHeader(root) {
    const ticker = $('[data-bt-ticker] ul', root);
    if (ticker && ticker.children.length > 1 && !reduceMotion) {
      let i = 0, paused = false;
      ticker.parentElement.addEventListener('mouseenter', () => paused = true);
      ticker.parentElement.addEventListener('mouseleave', () => paused = false);
      setInterval(() => { if (paused || document.hidden) return; i = (i + 1) % ticker.children.length; ticker.style.transform = `translateY(-${i * 34}px)`; }, 3800);
    }
    const mw = $('[data-bt-mega]', root);
    if (mw) {
      const mb = $('button', mw);
      const set = o => { mw.classList.toggle('is-open', o); mb.setAttribute('aria-expanded', o); };
      let t;
      mb.addEventListener('click', () => set(!mw.classList.contains('is-open')));
      // Short delay before closing so the pointer can travel from "Shop" down into the menu
      mw.addEventListener('mouseenter', () => { clearTimeout(t); set(true); });
      mw.addEventListener('mouseleave', () => { t = setTimeout(() => set(false), 250); });
      document.addEventListener('click', e => { if (!mw.contains(e.target)) set(false); });
      mw.addEventListener('keydown', e => { if (e.key === 'Escape') { set(false); mb.focus(); } });
    }
  }

  // ---------- Product cards ----------
  function pickCardSize(btn) {
    const card = btn.closest('[data-bt-card]');
    $$('[data-bt-size]', card).forEach(b => b.setAttribute('aria-pressed', b === btn));
    $('[data-bt-price]', card).textContent = btn.dataset.price;
    const compare = $('[data-bt-compare]', card), save = $('[data-bt-save-wrap]', card);
    compare.textContent = btn.dataset.compare;
    compare.hidden = !btn.dataset.compare;
    $('[data-bt-save]', card).textContent = btn.dataset.save;
    save.hidden = !btn.dataset.save;
    $('[data-bt-card-add]', card).dataset.id = btn.dataset.id;
    const img = $('img.is-main', card);
    if (img && btn.dataset.img) { img.removeAttribute('srcset'); img.src = btn.dataset.img; }
  }

  // ---------- Hero banner: each slide shows while its progress bar fills, then moves on ----------
  function initHero(root) {
    const hero = $('[data-bt-hero]', root) || (root.matches && root.matches('[data-bt-hero]') ? root : null);
    if (!hero) return;
    const slides = $$('.bt-slide', hero), segs = $$('.bt-seg', hero), banner = $('.bt-banner', hero), pauseBtn = $('[data-bt-pause]', hero);
    if (slides.length < 2) return;
    let cur = 0, userPaused = reduceMotion || hero.dataset.autoplay !== 'true';
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach((s, j) => { s.classList.toggle('is-on', j === cur); s.setAttribute('aria-hidden', j !== cur); s.tabIndex = j === cur ? 0 : -1; });
      segs.forEach((b, j) => {
        b.removeAttribute('aria-current');
        b.classList.toggle('is-done', j < cur);
        const bar = $('b', b); bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
      });
      segs[cur].setAttribute('aria-current', 'true');
    }
    // The fill animation ending is what advances the banner, so pausing the animation pauses the timer
    hero.addEventListener('animationend', e => { if (e.animationName === 'bt-fill') go(cur + 1); });
    segs.forEach((b, i) => b.addEventListener('click', () => go(i)));
    $('[data-bt-prev]', hero)?.addEventListener('click', () => go(cur - 1));
    $('[data-bt-next]', hero)?.addEventListener('click', () => go(cur + 1));
    const setPaused = () => hero.classList.toggle('is-paused', userPaused || banner.matches(':hover') || !!hero.querySelector(':focus-visible'));
    if (pauseBtn) {
      if (userPaused) pauseBtn.hidden = true;
      pauseBtn.addEventListener('click', () => { userPaused = !userPaused; pauseBtn.textContent = userPaused ? 'Play' : 'Pause'; setPaused(); });
    }
    ['mouseenter', 'mouseleave'].forEach(ev => banner.addEventListener(ev, () => setTimeout(setPaused)));
    ['focusin', 'focusout'].forEach(ev => hero.addEventListener(ev, () => setTimeout(setPaused)));
    let sx = null;
    banner.addEventListener('touchstart', e => sx = e.touches[0].clientX, { passive: true });
    banner.addEventListener('touchend', e => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); sx = null; });
    go(0); setPaused();
  }

  // ---------- What's inside: the pack with ingredient bowls bursting out around it ----------
  const HEAP = { 'Oats': '#EADFC4', 'White sorghum': '#F5EFE3', 'Sorghum': '#F5EFE3', 'Little millet': '#EAD9A2', 'Kodo millet': '#D2BC8C',
    'Foxtail millet': '#E6C766', 'Ragi': '#A8442E', 'Amaranth': '#E7D2A2', 'Chia seeds': '#4E4A46', 'Jaggery': '#B8742A', 'Cocoa': '#5A2E1B', 'Choco chips': '#3A1A0E' };
  function ingSVG(name, seed) {
    if (/banana/i.test(name)) return '<svg viewBox="0 0 100 100" aria-hidden="true"><ellipse cx="50" cy="86" rx="30" ry="5" fill="rgba(58,26,14,.15)"/><path d="M16 56c18 22 52 22 70-6 4-6 2-12-3-13-6 16-24 28-46 24-9-2-15-6-20-11-3 2-3 4-1 6z" fill="#FFD23F" stroke="#3A1A0E" stroke-width="3.5" stroke-linejoin="round"/><path d="M83 37l4-9" stroke="#3A1A0E" stroke-width="4" stroke-linecap="round"/><path d="M28 62c12 8 30 8 42-2" fill="none" stroke="#E8B41C" stroke-width="3" stroke-linecap="round"/></svg>';
    const c = HEAP[name] || '#E8D7A6';
    let dots = '';
    for (let i = 0; i < 14; i++) {
      const x = 28 + ((seed * 37 + i * 53) % 44), y = 34 + ((seed * 17 + i * 29) % 16);
      if (y > 32 + Math.abs(x - 50) * .5) dots += `<circle cx="${x}" cy="${y}" r="${name === 'Jaggery' ? 3.4 : 1.8}" fill="rgba(58,26,14,.22)"/>`;
    }
    return `<svg viewBox="0 0 100 100" aria-hidden="true"><ellipse cx="50" cy="88" rx="32" ry="5" fill="rgba(58,26,14,.15)"/>
      <path d="M18 52C24 30 38 20 50 20s26 10 32 32z" fill="${c}" stroke="#3A1A0E" stroke-width="3"/>${dots}
      <path d="M12 52h76a38 32 0 0 1-76 0z" fill="#FFF6E0" stroke="#3A1A0E" stroke-width="3.5" stroke-linejoin="round"/>
      <path d="M14 60h72" stroke="#FFB320" stroke-width="5"/></svg>`;
  }
  function initInside(root) {
    const sec = $('[data-bt-inside]', root);
    if (!sec) return;
    const data = JSON.parse($('[data-bt-inside-data]', sec).textContent);
    const stage = $('[data-bt-stage]', sec), orbit = $('[data-bt-orbit]', sec), pack = $('[data-bt-stage-pack]', sec);
    let current = 0, seen = false;
    function renderStage() {
      const f = data[current];
      const items = [...f.grains.map(g => g[0]), ...f.extras];
      stage.classList.toggle('is-choco', !!f.dark);
      if (f.pack) { pack.src = f.pack; pack.hidden = false; } else pack.hidden = true;
      pack.classList.remove('is-in'); void pack.offsetWidth; pack.classList.add('is-in');
      $('[data-bt-stage-note]', sec).textContent = f.note || '';
      const W = stage.clientWidth, n = items.length, size = n > 8 ? 17 : 20;
      orbit.innerHTML = items.map((name, i) => {
        const a = -Math.PI / 2 + (i / n) * Math.PI * 2;
        const x = 50 + Math.cos(a) * 37, y = 45 + Math.sin(a) * 31;
        const dx = (50 - x) / 100 * W, dy = (45 - y) / 100 * W;
        return `<div class="bt-ing" style="left:${x}%;top:${y}%;width:${size}%"><div class="bt-ing__in" style="--dx:${dx}px;--dy:${dy}px;animation-delay:${.35 + i * .09}s">${ingSVG(name, i + 1)}<small>${esc(name)}</small></div></div>`;
      }).join('');
    }
    function setTab(i) {
      current = i;
      const f = data[i];
      $$('[data-bt-tab]', sec).forEach((b, j) => b.setAttribute('aria-selected', j === i));
      $('[data-bt-grain-grid]', sec).innerHTML = [...f.grains, ...f.extras.map(x => [x, 'Also inside'])].map(([a, b]) => `<div class="bt-grain"><strong>${esc(a)}</strong><span>${esc(b)}</span></div>`).join('');
      $('[data-bt-ingr]', sec).innerHTML = f.ingredients;
      $('[data-bt-allergen]', sec).textContent = f.allergen;
      if (seen) renderStage();
    }
    $$('[data-bt-tab]', sec).forEach((b, i) => b.addEventListener('click', () => setTab(i)));
    setTab(0);
    // Play the burst the first time the section scrolls into view
    new IntersectionObserver(([e], obs) => { if (e.isIntersecting) { seen = true; renderStage(); obs.disconnect(); } }, { threshold: .35 }).observe(stage);
  }

  // ---------- Comparison rows slide in one by one ----------
  function initCompare(root) {
    const board = $('[data-bt-board]', root);
    if (!board) return;
    new IntersectionObserver(([e], obs) => {
      if (!e.isIntersecting) return;
      $$('.bt-row:not(.is-head)', board).forEach((r, i) => { r.style.animationDelay = i * .08 + 's'; r.classList.add('is-in'); });
      obs.disconnect();
    }, { threshold: .3 }).observe(board);
  }

  // ---------- Build your own box ----------
  function initCustom(root) {
    const box = $('[data-bt-custom]', root);
    if (!box) return;
    const price = +box.dataset.price, count = { a: 1, b: 1 };
    const btn = $('[data-bt-custom-add]', box), msg = $('[data-bt-custom-msg]', box);
    function render() {
      $$('[data-bt-custom-step]', box).forEach(s => $('output', s).textContent = count[s.dataset.btCustomStep]);
      const n = count.a + count.b, t = n * price;
      btn.textContent = n ? `Add ${n} ${n === 1 ? 'pack' : 'packs'} · ${money(t)}` : 'Pick at least 1 pack';
      btn.disabled = !n;
      msg.textContent = n === 0 ? 'Mix any number of packs. 3 or more ship free.'
        : t >= FREE_AT ? `${n * 7}–${n * 8} pancakes, and delivery is free!`
        : `${n * 7}–${n * 8} pancakes. Add ${Math.ceil((FREE_AT - t) / price)} more for free delivery.`;
    }
    $$('[data-bt-custom-step] button', box).forEach(b => b.addEventListener('click', () => {
      const k = b.closest('[data-bt-custom-step]').dataset.btCustomStep;
      count[k] = Math.max(0, Math.min(12, count[k] + +b.dataset.d));
      render();
    }));
    btn.addEventListener('click', () => addToCart([{ id: +box.dataset.a, quantity: count.a }, { id: +box.dataset.b, quantity: count.b }], btn));
    render();
  }

  // ---------- Product page ----------
  function initProduct(root) {
    const pdp = $('[data-bt-pdp]', root);
    if (!pdp) return;
    const variants = JSON.parse($('[data-bt-variants]', pdp).textContent);
    const state = { v: Math.max(0, variants.findIndex(v => v.selected)), qty: 1, img: 0 };
    const thumbs = $$('[data-bt-thumb]', pdp), big = $('[data-bt-big]', pdp), main = $('[data-bt-main-img]', pdp);
    const total = () => variants[state.v].price * state.qty;
    function showImg(i) {
      if (!thumbs.length) return;
      state.img = (i + thumbs.length) % thumbs.length;
      const t = thumbs[state.img];
      big.removeAttribute('srcset');
      big.src = t.dataset.full;
      big.alt = t.dataset.alt;
      thumbs.forEach((b, j) => b.setAttribute('aria-pressed', j === state.img));
      const counter = $('[data-bt-counter]', pdp);
      if (counter) counter.textContent = `${state.img + 1} / ${thumbs.length}`;
      main.classList.remove('is-zoom');
    }
    function render(userPicked) {
      const v = variants[state.v], packs = v.packs * state.qty, t = total();
      $$('[data-bt-psize]', pdp).forEach((b, i) => b.setAttribute('aria-pressed', i === state.v));
      $('[data-bt-pprice]', pdp).textContent = money(t);
      const compare = $('[data-bt-pcompare]', pdp), save = $('[data-bt-psave]', pdp), off = v.compare > v.price;
      compare.hidden = save.hidden = !off;
      compare.textContent = off ? money(v.compare * state.qty) : '';
      save.textContent = off ? `Save ${money((v.compare - v.price) * state.qty)}` : '';
      $('[data-bt-pcount]', pdp).textContent = `= ${packs * 7}–${packs * 8} pancakes`;
      $('[data-bt-qty]', pdp).textContent = state.qty;
      $('[data-bt-padd]', pdp).textContent = v.available ? `Add to cart · ${money(t)}` : 'Sold out';
      $('[data-bt-padd]', pdp).disabled = !v.available;
      $('[data-bt-buynow]', pdp).disabled = !v.available;
      const s = $('[data-bt-sticky]');
      if (s) { $('[data-bt-sadd]', s).textContent = `Add · ${money(t)}`; $('[data-bt-ssize]', s).textContent = `${v.label} · ${packs * 7}–${packs * 8} pancakes`; }
      const inCart = cart ? cart.total_price : 0, after = inCart + t, left = FREE_AT - after;
      $('[data-bt-free-meter]', pdp).style.width = Math.min(100, after / FREE_AT * 100) + '%';
      $('[data-bt-free-msg]', pdp).innerHTML = left > 0 ? `🚚 Add <b>${money(left)}</b> more for free delivery` : '🎉 This order gets <b>free delivery</b>';
      // Only put the pack size in the address once the visitor picks one
      if (userPicked) {
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url);
      }
    }
    $$('[data-bt-psize]', pdp).forEach((b, i) => b.addEventListener('click', () => {
      state.v = i;
      const mi = variants[i].media;
      if (mi !== null && mi !== undefined && mi >= 0) showImg(mi);
      render(true);
    }));
    $('[data-bt-minus]', pdp).addEventListener('click', () => { state.qty = Math.max(1, state.qty - 1); render(); });
    $('[data-bt-plus]', pdp).addEventListener('click', () => { state.qty = Math.min(10, state.qty + 1); render(); });
    const addNow = btn => addToCart([{ id: variants[state.v].id, quantity: state.qty }], btn);
    $('[data-bt-padd]', pdp).addEventListener('click', e => addNow(e.currentTarget));
    $('[data-bt-sadd]')?.addEventListener('click', e => addNow(e.currentTarget));
    // Buy it now: add this selection and go straight to Shopify checkout
    $('[data-bt-buynow]', pdp).addEventListener('click', async e => {
      const btn = e.currentTarget;
      btn.classList.add('is-busy');
      const r = await fetch('/cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [{ id: variants[state.v].id, quantity: state.qty }] }) });
      if (r.ok) location.href = '/checkout';
      else { btn.classList.remove('is-busy'); toast('Sorry, that could not be added.'); }
    });
    // Gallery: thumbnails, arrows, click to zoom, swipe
    thumbs.forEach((b, i) => b.addEventListener('click', () => showImg(i)));
    $('[data-bt-gprev]', pdp)?.addEventListener('click', e => { e.stopPropagation(); showImg(state.img - 1); });
    $('[data-bt-gnext]', pdp)?.addEventListener('click', e => { e.stopPropagation(); showImg(state.img + 1); });
    main.addEventListener('click', e => { if (!e.target.closest('.bt-gnav')) main.classList.toggle('is-zoom'); });
    main.addEventListener('mousemove', e => { const r = main.getBoundingClientRect(); big.style.transformOrigin = `${(e.clientX - r.left) / r.width * 100}% ${(e.clientY - r.top) / r.height * 100}%`; });
    main.addEventListener('mouseleave', () => main.classList.remove('is-zoom'));
    let tx = null;
    main.addEventListener('touchstart', e => tx = e.touches[0].clientX, { passive: true });
    main.addEventListener('touchend', e => { if (tx === null) return; const dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) showImg(state.img + (dx < 0 ? 1 : -1)); tx = null; });
    // Open on the first photo, unless the link asked for a specific pack size
    const startMedia = new URLSearchParams(location.search).has('variant') ? variants[state.v].media : 0;
    showImg(startMedia >= 0 ? startMedia : 0);
    cartListeners.push(() => render());
    render();
    // Sticky buy bar appears once the main Add to cart button scrolls away
    const sticky = $('[data-bt-sticky]');
    if (sticky) new IntersectionObserver(([en]) => sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe($('[data-bt-buyrow]', pdp));
    if (location.hash === '#nutrition') { const n = $('#nutrition'); if (n) { n.open = true; setTimeout(() => n.scrollIntoView({ block: 'center' }), 300); } }
  }

  // ---------- Global clicks (delegated so re-rendered sections keep working) ----------
  document.addEventListener('click', e => {
    const t = e.target;
    const open = t.closest('[data-bt-open]');
    if (open) { e.preventDefault(); openLayer(open.dataset.btOpen); return; }
    if (t.closest('[data-bt-close]') || t.closest('[data-bt-scrim]')) { closeLayer(); return; }
    if (openEl && openEl.matches('[data-bt-layer="mnav"], [data-bt-layer="search"]') && t.closest('a[href]')) { closeLayer(false); return; }
    const size = t.closest('[data-bt-card] [data-bt-size]');
    if (size) { pickCardSize(size); return; }
    const cardAdd = t.closest('[data-bt-card-add]');
    if (cardAdd) { addToCart([{ id: +cardAdd.dataset.id, quantity: 1 }], cardAdd); return; }
    const one = t.closest('[data-bt-add-one]');
    if (one) { addToCart([{ id: +one.dataset.btAddOne, quantity: 1 }], one); return; }
    const many = t.closest('[data-bt-add]');
    if (many) { addToCart(JSON.parse(many.dataset.btAdd), many); return; }
    const line = t.closest('[data-bt-line]');
    if (line) { changeLine(line.dataset.btLine, +line.dataset.qty); return; }
    if (t.closest('[data-bt-checkout]')) { location.href = '/checkout'; return; }
    const quick = t.closest('[data-bt-search-quick] button');
    if (quick) { const i = $('[data-bt-search-input]'); i.value = quick.textContent; renderSearch(); i.focus(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLayer(); });
  document.addEventListener('input', e => {
    if (e.target.matches('[data-bt-search-input]')) { clearTimeout(searchTimer); searchTimer = setTimeout(renderSearch, 180); }
  });
  function initAll(root = document) {
    initHeader(root); initHero(root); initInside(root); initCompare(root); initCustom(root); initProduct(root);
  }
  initAll();
  fetchCart();
  // Theme editor: re-run a section's script after it is re-rendered
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  window.BTCart = { add: addToCart, refresh: fetchCart, open: () => openLayer('cart') };
})();
